"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
var palletes = __importStar(require("./colors"));
var GlobalCss_1 = require("./global/GlobalCss");
Object.defineProperty(exports, "DefaultGlobalCss", { enumerable: true, get: function () { return GlobalCss_1.DefaultGlobalCss; } });
Object.defineProperty(exports, "GlobalCss", { enumerable: true, get: function () { return GlobalCss_1.GlobalCss; } });
__exportStar(require("./hooks"), exports);
__exportStar(require("./theme"), exports);
__exportStar(require("./utils"), exports);
exports.colors = palletes;
//# sourceMappingURL=index.js.map